import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

interface EcgSignal {
    time: number;
    value: number;
}

export const EcgDiag = (props: {
    ecg: number[];
    title: string;
    color: string;
}) => {
    const visRef = useRef<SVGSVGElement>(null);
    let datapoints_num = 4096;

    const slice_start = 1200;
    const slice_end = datapoints_num - slice_start;
    const slice_len = slice_end - slice_start;
    const y_data_2 = props.ecg.slice(slice_start, slice_end);

    if (slice_start > 0) {
        datapoints_num = slice_len;
    }

    let data_0: EcgSignal[] = y_data_2.map(function (d, i) {
        return {
            time: i,
            value: d,
        };
    });

    useEffect(() => {
        updateGraph();
    });

    const updateGraph = () => {
        if (!visRef.current) return;

        const svg = d3.select<SVGSVGElement, {}>(visRef.current);

        const width = 150;
        const height = 150;

        svg.selectAll("*").remove();

        let x_axis = d3
            .scaleLinear()
            .domain([0, datapoints_num])
            .range([0, width]);

        let y_axis = d3.scaleLinear().domain([-5, 5]).range([height, 0]);

        let lineGenerator = d3
            .line<EcgSignal>()
            .x((d) => x_axis(d.time))
            .y((d) => y_axis(d.value));

        svg.append("g").call(d3.axisLeft(y_axis));

        svg.append("path")
            .attr("fill", "none")
            .attr("stroke", props.color)
            .attr("stroke-width", 1.5)
            .attr("d", lineGenerator(data_0));

        svg.append("text")
            .attr("x", width / 2)
            .attr("y", 10)
            .attr("text-anchor", "middle")
            .style("font-size", "12px")
            .style("fill", props.color)
            .text(props.title);
    };

    return (
        <svg
            ref={visRef}
            viewBox="0 0 150 150"
            preserveAspectRatio="xMidYMid meet"
        />
    );
};
